"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var makeStyles_1 = require("@material-ui/core/styles/makeStyles");
var continueButtonsStyles = makeStyles_1.default(function (theme) { return ({
    continueButton: {
        height: 40,
        width: 180,
        borderRadius: 0,
        color: theme.palette.common.white,
        '& > span': {
            fontSize: theme.typography.fontXS,
            fontWeight: '300',
            textTransform: 'uppercase',
        },
    },
    icon: {
        color: theme.palette.common.white,
        fontSize: theme.typography.fontMD,
    },
    containedPrimary: {},
    contained: {},
}); }, { name: 'GqlCheckout_DealershipContinueButton' });
exports.default = continueButtonsStyles;
